export default __webpack_public_path__ + "static/media/viber.586d0fa4.svg";